import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation resources
import enCommon from '../locales/en/common.json';
import enDashboard from '../locales/en/dashboard.json';
import enOrders from '../locales/en/orders.json';
import enUsers from '../locales/en/users.json';
import enRMB from '../locales/en/rmb.json';
import enTransactions from '../locales/en/transactions.json';
import enWallets from '../locales/en/wallets.json';
import enSettings from '../locales/en/settings.json';
import enAuth from '../locales/en/auth.json';
import enSidebar from '../locales/en/sidebar.json';
import enItems from '../locales/en/items.json';
import enWalletManagement from '../locales/en/walletManagement.json';
import enInvoiceManagement from '../locales/en/invoiceManagement.json';
import enPaymentMethods from '../locales/en/paymentMethods.json';
import enWithdrawals from '../locales/en/withdrawals.json';
import enPackages from '../locales/en/packages.json';
import enLogistics from '../locales/en/logistics.json';
import enSystemMessages from '../locales/en/systemMessages.json';
import enBanners from '../locales/en/banners.json';
import enManualItemAdd from '../locales/en/manualItemAdd.json';
import enLocalSupplierItems from '../locales/en/localSupplierItems.json';
import enVersionManagement from '../locales/en/versionManagement.json';
import enCurrencyRates from '../locales/en/currencyRates.json';
import enAffiliate from '../locales/en/affiliate.json';
import enAI from '../locales/en/ai.json';
import enTranslateSettings from '../locales/en/translateSettings.json';
import enSearchHistory from '../locales/en/searchHistory.json';
import enAPIManagement from '../locales/en/apiManagement.json';
import enAPIKeyManagement from '../locales/en/apiKeyManagement.json';
import enAPIUsageLogs from '../locales/en/apiUsageLogs.json';
import enAPIStatistics from '../locales/en/apiStatistics.json';
import enProfitAnalytics from '../locales/en/profitAnalytics.json';
import enRMBProfitAnalytics from '../locales/en/rmbProfitAnalytics.json';
import enEmployees from '../locales/en/employees.json';
import enSalary from '../locales/en/salary.json';
import enFulfillment from '../locales/en/fulfillment.json';

import zhCommon from '../locales/zh/common.json';
import zhDashboard from '../locales/zh/dashboard.json';
import zhOrders from '../locales/zh/orders.json';
import zhUsers from '../locales/zh/users.json';
import zhRMB from '../locales/zh/rmb.json';
import zhTransactions from '../locales/zh/transactions.json';
import zhWallets from '../locales/zh/wallets.json';
import zhSettings from '../locales/zh/settings.json';
import zhAuth from '../locales/zh/auth.json';
import zhSidebar from '../locales/zh/sidebar.json';
import zhItems from '../locales/zh/items.json';
import zhWalletManagement from '../locales/zh/walletManagement.json';
import zhInvoiceManagement from '../locales/zh/invoiceManagement.json';
import zhPaymentMethods from '../locales/zh/paymentMethods.json';
import zhWithdrawals from '../locales/zh/withdrawals.json';
import zhPackages from '../locales/zh/packages.json';
import zhLogistics from '../locales/zh/logistics.json';
import zhSystemMessages from '../locales/zh/systemMessages.json';
import zhBanners from '../locales/zh/banners.json';
import zhManualItemAdd from '../locales/zh/manualItemAdd.json';
import zhLocalSupplierItems from '../locales/zh/localSupplierItems.json';
import zhVersionManagement from '../locales/zh/versionManagement.json';
import zhCurrencyRates from '../locales/zh/currencyRates.json';
import zhAffiliate from '../locales/zh/affiliate.json';
import zhAI from '../locales/zh/ai.json';
import zhTranslateSettings from '../locales/zh/translateSettings.json';
import zhSearchHistory from '../locales/zh/searchHistory.json';
import zhAPIManagement from '../locales/zh/apiManagement.json';
import zhAPIKeyManagement from '../locales/zh/apiKeyManagement.json';
import zhAPIUsageLogs from '../locales/zh/apiUsageLogs.json';
import zhAPIStatistics from '../locales/zh/apiStatistics.json';
import zhProfitAnalytics from '../locales/zh/profitAnalytics.json';
import zhRMBProfitAnalytics from '../locales/zh/rmbProfitAnalytics.json';
import zhEmployees from '../locales/zh/employees.json';
import zhSalary from '../locales/zh/salary.json';
import zhFulfillment from '../locales/zh/fulfillment.json';

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    orders: enOrders,
    users: enUsers,
    rmb: enRMB,
    transactions: enTransactions,
    wallets: enWallets,
    settings: enSettings,
    auth: enAuth,
    sidebar: enSidebar,
    items: enItems,
    walletManagement: enWalletManagement,
    invoiceManagement: enInvoiceManagement,
    paymentMethods: enPaymentMethods,
    withdrawals: enWithdrawals,
    packages: enPackages,
    logistics: enLogistics,
    systemMessages: enSystemMessages,
    banners: enBanners,
    manualItemAdd: enManualItemAdd,
    localSupplierItems: enLocalSupplierItems,
    versionManagement: enVersionManagement,
    currencyRates: enCurrencyRates,
    affiliate: enAffiliate,
    ai: enAI,
    translateSettings: enTranslateSettings,
    searchHistory: enSearchHistory,
    apiManagement: enAPIManagement,
    apiKeyManagement: enAPIKeyManagement,
    apiUsageLogs: enAPIUsageLogs,
    apiStatistics: enAPIStatistics,
    profitAnalytics: enProfitAnalytics,
    rmbProfitAnalytics: enRMBProfitAnalytics,
    employees: enEmployees,
    salary: enSalary,
    fulfillment: enFulfillment,
  },
  zh: {
    common: zhCommon,
    dashboard: zhDashboard,
    orders: zhOrders,
    users: zhUsers,
    rmb: zhRMB,
    transactions: zhTransactions,
    wallets: zhWallets,
    settings: zhSettings,
    auth: zhAuth,
    sidebar: zhSidebar,
    items: zhItems,
    walletManagement: zhWalletManagement,
    invoiceManagement: zhInvoiceManagement,
    paymentMethods: zhPaymentMethods,
    withdrawals: zhWithdrawals,
    packages: zhPackages,
    logistics: zhLogistics,
    systemMessages: zhSystemMessages,
    banners: zhBanners,
    manualItemAdd: zhManualItemAdd,
    localSupplierItems: zhLocalSupplierItems,
    versionManagement: zhVersionManagement,
    currencyRates: zhCurrencyRates,
    affiliate: zhAffiliate,
    ai: zhAI,
    translateSettings: zhTranslateSettings,
    searchHistory: zhSearchHistory,
    apiManagement: zhAPIManagement,
    apiKeyManagement: zhAPIKeyManagement,
    apiUsageLogs: zhAPIUsageLogs,
    apiStatistics: zhAPIStatistics,
    profitAnalytics: zhProfitAnalytics,
    rmbProfitAnalytics: zhRMBProfitAnalytics,
    employees: zhEmployees,
    salary: zhSalary,
    fulfillment: zhFulfillment,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'dashboard', 'orders', 'users', 'rmb', 'transactions', 'wallets', 'settings', 'auth', 'sidebar', 'items', 'walletManagement', 'invoiceManagement', 'paymentMethods', 'withdrawals', 'packages', 'logistics', 'systemMessages', 'banners', 'manualItemAdd', 'localSupplierItems', 'versionManagement', 'currencyRates', 'affiliate', 'ai', 'translateSettings', 'searchHistory', 'apiManagement', 'apiKeyManagement', 'apiUsageLogs', 'apiStatistics', 'profitAnalytics', 'rmbProfitAnalytics', 'employees', 'salary', 'fulfillment'],
    
    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // React i18next options
    react: {
      useSuspense: false,
    },
    
    // Fallback options
    saveMissing: false,
  });

export default i18n;

